<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';
</script>

<div class="dataset-match-key-comp">
  <div data-cy="match-info" class="dataset-match-info">
    <div class="icon"><Icon value="icon-check grey" fontSize={'18px'} /></div>
    <div class="text">Provided info matches verified result</div>
  </div>
  <div data-cy="not-match-info" class="dataset-match-info">
    <div class="icon"><Icon value="icon-alert-triangle grey" fontSize={'16px'} /></div>
    <div class="text">Provided info does not match verified result</div>
  </div>
</div>

<style>
  .dataset-match-key-comp {
    display: flex;
    color: var(--grey-medium);
  }
  .dataset-match-info {
    display: inline-flex;
  }

  .dataset-match-info:not(:first-child) {
    margin-left: 30px;
  }
  .dataset-match-info .text {
    margin-left: 8px;
  }
</style>
